import { STATUS } from "../../components/pages/Widget/constants";
import { OrderStatus } from "../../_utils";


export const actionTypes = {
  SAVE_ORDER_ID: "SAVE_ORDER_ID",
  SAVE_ORDER_STATUS: "SAVE_ORDER_STATUS",
  RESET_ORDER_STATUS: "RESET_ORDER_STATUS"
};


export const saveOrderId = (data: number) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_ORDER_ID,
    data: data,
  });
};

export const resetOrder = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_ORDER_STATUS
  });
};

// orderTypes = "update" | "cancel" | "load";
interface OrderInfo {
  id?: number,
  status?: OrderStatus,
  type: string
}


export const changeOrderStatus = (data: OrderInfo) => (dispatch, getState) => {
  const widget = getState().widget;
  let status = STATUS.load;
  if (data.id && data.id === widget.orderId) {
    if (data.status && data.status === OrderStatus.SelfMatch || data.type && data.type === "cancel") {
      status = STATUS.error
    } else {
      status = STATUS.done
    }
  } else {
    if (data.type && data.type === "cancel") status = STATUS.error
  }
  dispatch({
    type: actionTypes.SAVE_ORDER_STATUS,
    data: status,
  });
};
